import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/service/auth.service';

@Component({
  selector: 'app-education-dialog',
  templateUrl: './education-dialog.component.html',
  styleUrls: ['./education-dialog.component.scss']
})
export class EducationDialogComponent implements OnInit {
  jobCountry: string;
  constructor(private userService: AuthService) { }

  ngOnInit(): void {
    this.jobCountry = this.userService.getJobCountry();
  }

}
